import { render, staticRenderFns } from "./ManPreventivaOsErp.vue?vue&type=template&id=05e52dbf&"
import script from "./ManPreventivaOsErp.vue?vue&type=script&lang=js&"
export * from "./ManPreventivaOsErp.vue?vue&type=script&lang=js&"
import style0 from "./ManPreventivaOsErp.vue?vue&type=style&index=0&id=05e52dbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports